import i18n from "i18next"
import { initReactI18next } from "react-i18next"

import translationPt from 'locales/pt-BR/translation.json'
import translationEn from 'locales/en/translation.json'
import translationEs from 'locales/es-MX/translation.json'

const resources = {
  ptBR: {
    translation: translationPt
  },
  esMX: {
    translation: translationEs
  },
  en: {
    translation: translationEn
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "ptBR",
    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  })

export default i18n
